import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

import RegisterMenu from "./component/register/registerMenu";
import HomePageSettingMenu from "./component/common/homepageSettingMenu";
import BoardView from "./component/register/registerNoticeView/boardView";
import PageInfo from "../pageInfo";

import { setRegisterIndex } from "../../../store/compoIndex";

import { Container } from "../styled/mypage";
import { RegisterNoticeViewContainer } from "./component/styled/register";

export default function RegisterNoticeView() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const index = useSelector((state) => state.compoIndex.register);
  const user = useSelector((state) => state?.user?.data[0]);
  const setting = useSelector((state) => state?.user?.setting);
  const companyInfo = useSelector((state) => state?.company?.companyInfo);

  const [cmpnyNo, setCmpnyNo] = useState();
  const [currentAuth, setCurrentAuth] = useState("VIEWER");

  useEffect(() => {
    const url = window.location.href;
    if (url.includes("register")) {
      dispatch(setRegisterIndex(3));
    }

    const company = JSON.parse(sessionStorage.getItem("homepageCompany"));

    if (!company) {
      console.log("선택된 회사가 존재하지 않습니다.");
      navigate("/mypage");
    } else {
      setCmpnyNo(company.cmpnyNo);
      setCurrentAuth(
        companyInfo?.find?.((info) => info.cmpnyNo === company.cmpnyNo)?.auth || "VIEWER",
      );
    }
  }, []);

  return (
    <Container className={setting?.mode}>
      <PageInfo label="공지사항" />
      <div className="content">
        <HomePageSettingMenu />
        <RegisterMenu index={index} />
        <RegisterNoticeViewContainer className={setting?.mode}>
          <BoardView
            userName={user?.userName}
            cmpnyNo={cmpnyNo}
            setting={setting}
            currentAuth={currentAuth}
          />
        </RegisterNoticeViewContainer>
      </div>
    </Container>
  );
}
